import React, { SetStateAction, useEffect, useRef, useState } from "react";
import {
  TextField,
  Box,
  FormControl,
  InputLabel,
  Stack,
  useTheme,
  SelectChangeEvent,
  Typography,
  Switch,
  Select,
  MenuItem,
} from "@mui/material";
import { Agent } from "../../../Shared-ui/Types/Agent";
import { NotSelected } from "../../../Constant/Setting";
import { useDispatch } from "react-redux";

interface MyComponentProps {
  agent: Agent;
  setAgent: React.Dispatch<SetStateAction<Agent>>;
  AgentErr: any;
  userGroups: any[];
  selectedGroups: string[];
  setSelectedGroups: React.Dispatch<SetStateAction<string[]>>;
  unSelectedGroups: string[];
  setUnSelectedGroups: React.Dispatch<SetStateAction<string[]>>;
}

const GeneralSettings: React.FC<MyComponentProps> = (props) => {
  const theme = useTheme();
  // const [models, setModels] = useState<{ label: string; value: string }[]>([])
  const [modelsAndProvider, setModelsAndProvider] = useState();
  const [providers, setProviders] = useState<string[]>([]);
  const [models, setModels] = useState<string[]>([]);
  const [selectedProvider, setSelectedProvider] = useState<string>(NotSelected);
  const [storage, setStorage] = useState("in-memory");
  const [groupSearch, setGroupSearch] = useState("");

  // function getModelOptionsOld(modelData: Record<string, string[]>): { label: string; value: string }[] {
  //   const options: { label: string; value: string }[] = [];

  //   for (const provider in modelData) {
  //     if (Object.prototype.hasOwnProperty.call(modelData, provider)) {
  //       const models = modelData[provider];
  //       for (const model of models) {
  //         options.push({
  //           label: `${provider} — ${model}`,
  //           value: `${provider}:${model}`
  //         });
  //       }
  //     }
  //   }
  //   return options;
  // }

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    const name = event.target.name;
    props.setAgent((preVal) => ({ ...preVal, [name]: checked }));
  };

  const handleMetaDataSwitchChanges = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    const name = event.target.name;
    props.setAgent((preVal) => {
      return {
        ...preVal,
        agent_metadata: { ...preVal.agent_metadata, [name]: checked },
      };
    });
  };

  const handleMetaDataTextChanges = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    props.setAgent((preVal) => {
      return {
        ...preVal,
        agent_metadata: { ...preVal.agent_metadata, [name]: value },
      };
    });
  };
  const handleChnage = (
    event:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent
  ) => {
    const { name, value } = event.target;
    props.setAgent((preVal) => ({ ...preVal, [name]: value }));
  };

  const filteredGroups = props.userGroups.filter((group) =>
    group.name.toLowerCase().includes(groupSearch.toLowerCase())
  );

  const handleGroupCheck = (groupId: string) => {
    if (groupId) {
      props.setSelectedGroups((prev) => {
        if (prev.includes(groupId)) {
          // If unchecked, add to unSelectedGroups
          props.setUnSelectedGroups((unPrev) => [...unPrev, groupId]);
          return prev.filter((uid) => uid !== groupId);
        } else {
          // If checked, remove from unSelectedGroups if present
          props.setUnSelectedGroups((unPrev) =>
            unPrev.filter((uid) => uid !== groupId)
          );
          return [...prev, groupId];
        }
      });
    }
  };

  const zeaSecureRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (props.agent.agent_metadata.enable_zeasecure && zeaSecureRef.current) {
      zeaSecureRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [props.agent.agent_metadata.enable_zeasecure]);

  return (
    <Box sx={{}}>
      <Typography
        variant="subtitle2"
        sx={{ display: { xs: "block", md: "none" }, mb: 2, mt: 1 }}
      >
        General Settings
      </Typography>
      <Box
        sx={{
          p: theme.spacing(0),
          display: "flex",
          gap: 3,
          flexDirection: { xs: "column", md: "row" },
          mt: { xs: 0, md: 2 },
        }}
      >
        <Stack
          spacing={2}
          sx={{
            flex: { xs: "1 1 100%", md: 2 },
            minWidth: { xs: "100%", md: 0 },
            width: { xs: "100%", md: "auto" },
          }}
        >
          <FormControl fullWidth variant="outlined">
            <InputLabel
              shrink
              htmlFor="name"
              sx={{ background: "#fff", px: 0.5 }}
            >
              Name *
            </InputLabel>
            {/* Name Field */}
            <TextField
              required
              placeholder="Customer Support Agent"
              value={props.agent.name}
              name="name"
              onChange={handleChnage}
              helperText={props.AgentErr.name.error}
              error={props.AgentErr.name.value}
              fullWidth
              variant="outlined"
              inputProps={{ maxLength: 50 }}
            />
          </FormControl>

          {/* Description Field */}
          <FormControl fullWidth variant="outlined">
            <InputLabel
              shrink
              htmlFor="name"
              sx={{ background: "#fff", px: 0.5 }}
            >
              Description *
            </InputLabel>
            <TextField
              placeholder="Enter agent description"
              value={props.agent.description}
              name="description"
              onChange={handleChnage}
              helperText={props.AgentErr.description.error}
              error={props.AgentErr.description.value}
              multiline
              minRows={9}
              maxRows={9}
              fullWidth
              variant="outlined"
              inputProps={{ maxLength: 1000 }}
            />
          </FormControl>

          {/* Role Field */}
          <FormControl
            fullWidth
            variant="outlined"
            error={props.AgentErr.role.value}
          >
            <InputLabel
              shrink
              htmlFor="role"
              sx={{ background: "#fff", px: 0.5 }}
            >
              Agent role *
            </InputLabel>
            <Select
              label="Agent role *"
              value={props.agent.role}
              name="role"
              onChange={handleChnage}
              displayEmpty
              inputProps={{ id: "role" }}
            >
              <MenuItem value={props.agent.role}>{props.agent.role}</MenuItem>
            </Select>
            {props.AgentErr.role.error && (
              <Typography variant="caption" color="error">
                {props.AgentErr.role.error}
              </Typography>
            )}
          </FormControl>
        </Stack>
        <Box
          p={theme.spacing(0)}
          sx={{
            flex: { xs: "1 1 100%", md: 1 },
            minWidth: { xs: "100%", md: 0 },
            width: { xs: "100%", md: "auto" },
          }}
        >
          <Stack
            spacing={2}
            sx={{
              height: "382px",
              overflowY: "auto",
            }}
          >
            {/* Show Tool Calls */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                border: "1px solid",
                borderColor: "#c4c4c4",
                padding: "8px 16px",
                borderRadius: 1,
              }}
            >
              <Box flexGrow={1}>
                <Typography variant="subtitle1" sx={{ lineHeight: "18px" }}>
                  Show Tool Calls
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Display tool usage in the conversation
                </Typography>
              </Box>
              <Switch
                checked={props.agent.show_tool_calls}
                name="show_tool_calls"
                onChange={handleSwitchChange}
              />
            </Box>

            {/* is_shared */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                border: "1px solid",
                borderColor: "#c4c4c4",
                padding: "8px 16px",
                borderRadius: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Box flexGrow={1}>
                  <Typography variant="subtitle1">Shared Agent</Typography>
                  <Typography variant="body2" color="textSecondary">
                    To share agent
                  </Typography>
                </Box>
                <Switch
                  checked={props.agent.is_shared}
                  name="is_shared"
                  onChange={handleSwitchChange}
                />
              </Box>
              {props.agent.is_shared && (
                <Box
                  sx={{
                    width: "100%",
                    maxHeight: 320, // Set a max height for the whole box
                    overflow: "auto", // Enable scrolling for the box
                  }}
                >
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Assign groups
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    label="Search Users"
                    value={groupSearch}
                    onChange={(e) => setGroupSearch(e.target.value)}
                    placeholder="Search by name"
                    sx={{ mb: 2 }}
                  />
                  <Box sx={{ maxHeight: 200, overflowY: "auto" }}>
                    {filteredGroups.map(
                      (group) =>
                        group.id && (
                          <Box
                            key={group.id}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={props.selectedGroups.includes(group.id)}
                              onChange={() => handleGroupCheck(group.id || "")}
                              id={`user-checkbox-${group.id}`}
                            />
                            <label
                              htmlFor={`user-checkbox-${group.id}`}
                              style={{ marginLeft: 8 }}
                            >
                              {group.name}
                            </label>
                          </Box>
                        )
                    )}
                  </Box>
                </Box>
              )}
            </Box>

            {/* is_active */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                border: "1px solid",
                borderColor: "#c4c4c4",
                padding: "8px 16px",
                borderRadius: 1,
              }}
            >
              <Box flexGrow={1}>
                <Typography variant="subtitle1">Enable Agent </Typography>
                <Typography variant="body2" color="textSecondary">
                  To enable agent
                </Typography>
              </Box>
              <Switch
                checked={props.agent.is_active}
                name="is_active"
                onChange={handleSwitchChange}
              />
            </Box>

            {/* Enable Markdown */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                border: "1px solid",
                borderColor: "#c4c4c4",
                padding: "8px 16px",
                borderRadius: 1,
              }}
            >
              <Box flexGrow={1}>
                <Typography variant="subtitle1">Enable Markdown</Typography>
                <Typography variant="body2" color="textSecondary">
                  Format responses with Markdown
                </Typography>
              </Box>
              <Switch
                checked={props.agent.agent_metadata.markdown}
                name="markdown"
                onChange={handleMetaDataSwitchChanges}
              />
            </Box>

            {/* Enable streaming */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                border: "1px solid",
                borderColor: "#c4c4c4",
                padding: "8px 16px",
                borderRadius: 1,
              }}
            >
              <Box flexGrow={1}>
                <Typography variant="subtitle1">Enable Streaming</Typography>
                <Typography variant="body2" color="textSecondary">
                  Streaming response
                </Typography>
              </Box>
              <Switch
                checked={props.agent.agent_metadata.streaming}
                name="streaming"
                onChange={handleMetaDataSwitchChanges}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                border: "1px solid",
                borderColor: "#c4c4c4",
                padding: "8px 16px",
                borderRadius: 1,
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box flexGrow={1}>
                  <Typography variant="subtitle1">Enable ZeaSecure</Typography>
                  <Typography variant="body2" color="textSecondary">
                    Enable ZeaSecure
                  </Typography>
                </Box>
                <Switch
                  checked={props.agent.agent_metadata.enable_zeasecure}
                  name="enable_zeasecure"
                  onChange={handleMetaDataSwitchChanges}
                />
              </Box>
              {props.agent.agent_metadata.enable_zeasecure && (
                <Box ref={zeaSecureRef} sx={{ width: "100%" }}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={props.AgentErr.zeasecure_api_key.value}
                  >
                    <InputLabel
                      shrink
                      htmlFor="zeasecure_api_key"
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      API Key *
                    </InputLabel>
                    <TextField
                      placeholder="zsk_2e4bxxxxxxxxxxxxxxxxxxxxxxxx2d0c"
                      value={props.agent.agent_metadata.zeasecure_api_key}
                      name="zeasecure_api_key"
                      onChange={handleMetaDataTextChanges}
                      helperText={props.AgentErr.zeasecure_api_key.error}
                      error={props.AgentErr.zeasecure_api_key.value}
                      fullWidth
                      variant="outlined"
                      inputProps={{ maxLength: 36 }}
                    />
                  </FormControl>
                </Box>
              )}
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default GeneralSettings;
